import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRegisterDataIntegrationStepControls } from 'src/features/Signup/hooks/useRegisterDataIntegrationStepControls';
import { useUpdateCustomerMutation } from 'src/api/mutations';
import { useAppContext } from 'src/contexts/AppContext';
import { InviteColleaguesStep } from 'src/features/Signup/components/templates/DataIntegrationFlow/steps/InviteColleaguesStep';
import {
  getStepIndex,
  getNextStepPath,
  getPrevStepPath,
} from 'src/features/Signup/utils/dataIntegrationSteps';

const nextPath = getNextStepPath('invite-colleagues');
const prevPath = getPrevStepPath('invite-colleagues');

export const InviteColleaguesStepRoute: React.FC = () => {
  const navigate = useNavigate();
  const updateCustomerMutation = useUpdateCustomerMutation();
  const { currentCustomer } = useAppContext();
  const customerId = currentCustomer?.customerName || '';

  const handleFinish = async () => {
    await updateCustomerMutation.mutateAsync({
      id: customerId,
      isRegistrationStarted: false,
    });
    // Hard redirect to exit the registration flow
    window.location.href = '/';
  };

  useRegisterDataIntegrationStepControls({
    title: 'Invite colleagues',
    subtitle: 'Grow your network by inviting trusted colleagues',
    currentStep: getStepIndex('invite-colleagues'),
    // Last step has custom onNext to finish registration
    onNext: nextPath ? () => navigate(nextPath) : handleFinish,
    onBack: prevPath ? () => navigate(prevPath) : undefined,
    isBackDisabled: false,
    isNextDisabled: false,
  });

  return <InviteColleaguesStep />;
};
